import { render, staticRenderFns } from "./mytable.vue?vue&type=template&id=11bc47c4"
import script from "./mytable.vue?vue&type=script&lang=js"
export * from "./mytable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports